import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import ErrorPage from 'pages/ErrorPage';
import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.scss';
import { AppContext, AppContextManager, IAppContext } from './config/AppContext';
import router from './config/router';
import { IUser } from './types/user-type';

interface AppProps {
  user: IUser
}

function App(pops: AppProps) {
  // #region context
  const [context, setAppContext] = useState<IAppContext>({
    user: pops.user,
    stateData: {}
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    uri: "/graphql"
  });

  const manager = new AppContextManager(context, setAppContext as (i: Partial<IAppContext>) => void);
  // #endregion context

  return (
    <AppContext.Provider value={manager}>
       <ApolloProvider client={client}>
        <RouterProvider router={router(pops.user)} />
      </ApolloProvider>
    </AppContext.Provider>
  );
}

export default App;
